import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MainHeader from '@Local/Components/Header/MainHeader';
import MainFooter from '@Local/Components/Footer/MainFooter';
import { MainLayoutProvider } from "@Local/Components/Layout/Context/MainLaydoutContext";
import { HEADER_TYPE, FOOTER_TYPE, THEME_TYPE } from "@Constants/dataEnums";
import { useThemeController } from "@Local/Components/Layout/Hook/useThemeController";
import { useHeaderHeightVar } from "@Local/Components/Layout/Hook/useHeaderHeightVar";
import DevPageMenu from '@Local/Components/Layout/DevPageMenu';
import ErrorBoundary from '@Local/Components/ErrorBoundary/ErrorBoundary';

// 功能：開發用頁面選單僅在本機開發環境顯示，正式站與 UAT 皆不渲染
const isDevelopment = process.env.NODE_ENV === 'development';

const MainLayout = ({ children }) => {
    const [headerType, setHeaderType] = useState(HEADER_TYPE.DEFAULT);
    const [footerType, setFooterType] = useState(FOOTER_TYPE.DEFAULT);
    const [themeType, setThemeType] = useState(THEME_TYPE.DEFAULT);
    // 功能：Header 自訂內容插槽（頁面可塞入 Stepper 等自訂元件，null 時維持預設 logo/user）
    const [headerContent, setHeaderContent] = useState(null);
    // 功能：量測 Header 實際高度，供 .main-container padding-top 對齊
    const headerRef = useRef(null);
    const { pathname } = useLocation();

    useThemeController({ themeType })
    useHeaderHeightVar(headerRef)

    return (
        <MainLayoutProvider value={{ setHeaderType, setFooterType, setThemeType, setHeaderContent }}>
            <MainHeader ref={headerRef} headerType={headerType} headerContent={headerContent} />
            <div className={'main-container'}>
                {/* 功能：頁面內容出錯時保留 header / footer，只在內容區顯示錯誤資訊；換頁自動恢復 */}
                <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>
            </div>
            <MainFooter footerType={footerType} />
            {/*
             * 刻意放在 <header> 之外：部分頁面設 HEADER_TYPE.UNFIXED，header 會隨內容捲走，
             * 掛在 header 裡的選單在那些頁面滾一下就不見。改由自身 position: fixed 貼住視窗，
             * 所有走 MainLayout 的頁面都固定可用，也不影響 header 版面。
             */}
            {isDevelopment && <DevPageMenu />}
        </MainLayoutProvider>
    );
};

export default MainLayout;
